module.exports = __webpack_public_path__ + "img/guandai_xc2.9b70b7f0.jpg";